import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	addObject: {
		id: 'issue-field-cmdb-object.label.add-object',
		defaultMessage: 'Add object',
		description: 'Text for button that opens a search box for adding a Insight object',
	},
	editField: {
		id: 'issue-field-cmdb-object.label.edit-field',
		defaultMessage: 'Edit Field',
		description: 'Label for button icon that, when clicked, will begin editing a field',
	},
	showDetails: {
		id: 'issue-field-cmdb-object.label.show-details',
		defaultMessage: 'Show details',
		description: 'Label/Tooltip for button icon that shows objects for a Insight field',
	},
	hideDetails: {
		id: 'issue-field-cmdb-object.label.hide-details',
		defaultMessage: 'Hide details',
		description: 'Label/Tooltip for button icon that hides objects for a Insight field',
	},
	objectCount: {
		id: 'issue-field-cmdb-object.label.object-count',
		defaultMessage: '{count, plural, one {# Object} other {# Objects}}',
		description: 'Text for the number of objects in the Insight field',
	},
});
